module.exports = __webpack_public_path__ + "static/media/gamer.5486b48b.svg";